//Import Modules
import $ from 'jquery';

//Switches the Background Gradient while scrolling.
//A Section is active while it crosses a fixed Trigger Line at a third of the
//Viewport Height, so the Colour is already in place when the Section arrives.
//The Gradients sit on stacked fixed Layers instead of on the Body, because
//background-image cannot be transitioned - only the Layer Opacity can.
//Expects the LocomotiveScroll Instance of the Page.
const initBackgroundChange = (scroll) =>{
  var sections = [];
  var layers = {};
  var triggerLine = 0;
  var scrollY = 0;
  var currentColor;

  //Measures Layout Positions once instead of on every Scroll Tick.
  //LocomotiveScroll does not scroll the Document, it transforms the Container,
  //so position() is relative to the Viewport. Adding the current Scroll Offset
  //back turns it into a Position inside the Document that stays valid until
  //the Layout changes.
  const measureSections = () =>{
    triggerLine = $(window).height()/3;
    sections = $('[data-scroll-container] .base-section').map(function(){
      const $section = $(this);
      return {
        top: $section.position().top + scrollY,
        height: $section.height(),
        color: $section.data('color')
      };
    }).get();
  }

  //One Layer per distinct Colour, created once. The .color-* Classes only set
  //background-image, so they work on any Element.
  const buildLayers = () =>{
    sections.forEach((section)=>{
      if(section.color && !layers[section.color]){
        layers[section.color] = $('<div class="bg-layer"></div>')
          .addClass('color-' + section.color)
          .prependTo('body');
      }
    });
  }

  //Crossfades to the Layer of the given Colour. A Section without a data-color
  //hides every Layer and falls back to the plain Body Background.
  const applyColor = (color) =>{
    if(color === currentColor){
      return;
    }
    currentColor = color;
    $.each(layers, (name, $layer)=>{
      $layer.toggleClass('is-visible', name === color);
    });
  }

  //Finds the Section crossing the Trigger Line.
  //The last Match wins, same as iterating in DOM Order before.
  const updateColor = () =>{
    var activeColor = null;
    var found = false;
    for(var i = 0; i < sections.length; i++){
      const top = sections[i].top - scrollY;
      if(top <= triggerLine && top + sections[i].height > triggerLine){
        activeColor = sections[i].color || null;
        found = true;
      }
    }
    //No Match keeps the current Colour, just like the original Loop did
    if(found){
      applyColor(activeColor);
    }
  }

  const refresh = () =>{
    measureSections();
    buildLayers();
    updateColor();
  }

  scroll.on("scroll", (position)=>{
    scrollY = position.scroll.y;
    updateColor();
  });

  //Runs once so the Start Colour is in place before the first Scroll Event.
  //The Layers are created and switched on in the same Task, so their first
  //computed Style is already the visible one and the Start Colour does not
  //fade in.
  refresh();
  $(window).on("load resize", refresh);
}

export {initBackgroundChange};
